import { createNavigation } from 'next-intl/navigation'
import type { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { routing } from './routing'

const navigation = createNavigation(routing)

export const Link = navigation.Link
export const getPathname = navigation.getPathname
export const redirect = navigation.redirect
export const usePathname = navigation.usePathname
export const useRouter: () => AppRouterInstance = navigation.useRouter
